// breadcrumbs.component.ts
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

interface Breadcrumb {
  label: string;
  url: string;
}

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css'],
})
export class BreadcrumbsComponent implements OnInit {
  public breadcrumbs: Breadcrumb[] = [];

  constructor(private router: Router, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    // 1) Generamos al inicio
    this.generateBreadcrumbs();

    // 2) Re-generamos en cada cambio de ruta completo
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => this.generateBreadcrumbs());
  }

  private generateBreadcrumbs(): void {
    const root = this.router.routerState.snapshot.root;
    this.breadcrumbs = this.buildBreadcrumbs(root);
    this.cdr.detectChanges();
  }

  private buildBreadcrumbs(
    route: ActivatedRouteSnapshot,
    url: string = '',
    crumbs: Breadcrumb[] = []
  ): Breadcrumb[] {
    const config = route.routeConfig;

    // Añadimos esta ruta si tiene dato `breadcrumb`
    if (config?.data?.['breadcrumb']) {
      crumbs.push({
        label: config.data['breadcrumb'],
        url,
      });
    }

    // Buscamos al hijo activo
    const child = route.firstChild;
    if (!child) {
      return crumbs;
    }

    // Reconstruimos el fragmento de URL, sustituimos params
    let path = child.routeConfig?.path || '';
    Object.entries(child.params).forEach(([key, val]) => {
      path = path.replace(`:${key}`, String(val));
    });

    const nextUrl = path ? `${url}/${path}` : url;
    return this.buildBreadcrumbs(child, nextUrl, crumbs);
  }
}
